(async()=>{
    var e = await import(window.theme.modules.baseComponent);
    customElements.define("product-qty", class extends e.default {
        render() {
            this.currentVariant = +this.getAttribute("variant-id"),
            this.listenTo("variantChange", (e,t)=>{
                this.currentVariant = t.variant.id,
                this._rerender(t)
            }
            ),
            this.listenTo("qtyStatusUpdate", (e,t)=>{
                this.currentVariant === +t.variantId && this._rerender(t)
            }
            , !1)
            
            this.addEventListener("change", function(){
              var input = document.querySelector("[data-variant-quantity-input]");
                debugger;
              if(input){
              input.value = this.querySelector("select").value;
              }
            })
            
        }
        _rerender(e) {
            const t = e.html.querySelector("product-qty");
            e = this.querySelector("select")?.value;
          
            if (e) {
                const r = t.querySelector(`option[value="${e}"]`);
                r && r.setAttribute("selected", !0);
              var input = document.querySelector("[data-variant-quantity-input]");
              if(input){
              input.value = e;
              }
        }else{
              var input = document.querySelector("[data-variant-quantity-input]");
              if(input){
              input.value = 1;
              }
        }
            this.replaceChildren(...t.cloneNode(!0).childNodes)
        }
    }
    )
}
)();
